import { czDateStringToDate } from '@evidia/shared';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const isSameOrBeforeDay = (date: Dayjs | string): boolean => {
	if (typeof date === 'string') {
		return dayjs().isSameOrBefore(czDateStringToDate(date), 'day');
	}
	return dayjs().isSameOrBefore(date, 'day');
};

export const isSameOrAfterDay = (date: Dayjs | string): boolean => {
	if (typeof date === 'string') {
		return dayjs().isSameOrAfter(czDateStringToDate(date), 'day');
	}
	return dayjs().isSameOrAfter(date, 'day');
};

export const mergeDateAndTime = (date: Date, time: Date): Date => {
	// Zkopírování data z objektu date
	const newDate = new Date(date);

	// Získání hodin a minut z objektu času
	const hours = time.getHours();
	const minutes = time.getMinutes();

	// Nastavení hodin a minut k novému objektu data
	newDate.setHours(hours);
	newDate.setMinutes(minutes);

	return newDate;
};
